import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { View, ViewOpts } from '@play-co/timestep-core/ui';
import Scroll from 'src/game/components/shared/Scroll';
import { chunkArray } from 'src/replicant/utils/array';
import { Card, CardState } from './Card';
import sounds from 'src/lib/sounds';
import { cardsOpenCardDetails } from '../cards.sequence';

export type CardsListState = { cards: CardState[] };

type CardsListLine = [CardState, CardState?, CardState?];

export class CardsList extends View {
  private scroll: Scroll<CardsListLine, View>;

  constructor(opts: ViewOpts) {
    super(opts);

    this.scroll = new Scroll<CardsListLine>({
      superview: this,
      createItem: (superview, _, data) => {
        const line = new FlexBoxView({
          superview,
          width: this.style.width,
          height: 272,
          flex: {
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        });

        for (let i = 0; i < 3; i++) {
          const icon = new Card({ superview: line });
          icon.setState(data[i]);
          icon.onClick = async () => {
            sounds.sfx.play('ok');

            await this.triggerPopup(icon);
          };
        }

        return line;
      },

      recycle: true,
      setData: (_, icons, view) => {
        icons.forEach((icon, i) => {
          const card = view.getSubview(i) as Card;
          card?.setState(icon);
        });
      },
      rect: {
        x: 0,
        y: 0,
        width: this.style.width,
        height: this.style.height,
      },
    });
  }

  public setState(state: CardsListState) {
    const listData: CardsListLine[] = [];

    chunkArray(state.cards, 3).forEach((chunk) => {
      const data = [];
      for (let i = 0; i < 3; i++) {
        data.push(chunk[i]);
      }

      listData.push(data as CardsListLine);
    });

    this.scroll.setItems(listData);
  }

  private async triggerPopup(card: Card) {
    if (!card.currentState) return;

    const sent = await cardsOpenCardDetails(card.currentState);

    if (sent) {
      card.setState({
        ...card.currentState,
        new: false,
        count: card.currentState.count - sent,
      });
    }
  }
}
